import { render, staticRenderFns } from "./OutOfStockBlock.vue?vue&type=template&id=3692c31b&"
import script from "./OutOfStockBlock.vue?vue&type=script&lang=js&"
export * from "./OutOfStockBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports